const fallbackCopyToClipboard = (selector: HTMLElement): boolean => {
  const r = document.createRange();
  r.selectNodeContents(selector);
  window.getSelection()?.removeAllRanges();
  window.getSelection()?.addRange(r);
  try {
    document.execCommand('copy');
    window.getSelection()?.removeAllRanges();
    return true;
  } catch (err) {
    return false;
  }
};

export const copyToClipboard = (id: string, partialCopyId?: string) => {
  const selector = document.getElementById(partialCopyId || id);
  if (!selector) {
    return false;
  }

  const text = (selector.textContent || '').trim();

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).catch(() => {
      fallbackCopyToClipboard(selector);
    });
    return true;
  }

  return fallbackCopyToClipboard(selector);
};

export const hideSuccessCopyTimeout = (handleHide: (value: boolean) => void) =>
  setTimeout(() => {
    handleHide(false);
  }, 2000);
